import { useState } from 'react';

import { SuggestInput } from '../../components/SuggestInput';
import { useDebounced } from '../../lib/useDebounced';
import { useCustomFieldSuggestions } from './queries';

interface CustomFieldSuggestInputProps {
  id: string;
  definitionId: string;
  value: string;
  onChange: (value: string) => void;
}

/**
 * Ein eigenes Textfeld mit Vorschlaegen aus den bisher erfassten Werten.
 *
 * Nur in der Bearbeitungsoberflaeche: Der Server liefert die Vorschlaege
 * keinem Portalnutzer, weil sie aus den Tickets aller Kunden stammen. Scheitert
 * die Abfrage, bleibt es ein gewoehnliches Textfeld.
 */
export function CustomFieldSuggestInput({
  id,
  definitionId,
  value,
  onChange,
}: CustomFieldSuggestInputProps) {
  const [term, setTerm] = useState('');
  const [opened, setOpened] = useState(false);
  const suggestions = useCustomFieldSuggestions(definitionId, useDebounced(term), opened);

  return (
    <SuggestInput
      id={id}
      value={value}
      onChange={onChange}
      suggestions={suggestions.data ?? []}
      loading={suggestions.isFetching}
      onSearch={(next) => {
        setOpened(true);
        setTerm(next);
      }}
    />
  );
}
